import React from "react";
import { Dropdown } from "react-bootstrap";
import { BoxArrowLeft, PersonFill } from "react-bootstrap-icons";
import Style from "./DropDownExit.module.scss";
import "./ActiveOrderContainer.css";
import { LogoutAPI } from "../../Api/PanelAdminServices";
import { errorToast } from "../../Utils/Toast/Toast";
import { useHistory } from "react-router-dom";

/////////////////// Logout Part ///////////////////////
const DropDownExit = () => {

  let history = useHistory();

  const LogoutHandler = () => {
    let info = {
      logout: "",
    };
    LogoutAPI(info, (succ) => {
      if (succ.status === 1) {
        localStorage.clear();
        setTimeout(() => {
          window.location.reload()
        }, 100);
      } else {
        errorToast("مشکلی پیش آمده");
      }
    });
  };

  return (
    <Dropdown>
      <Dropdown.Toggle
        variant="secondary"
        id="dropdown-basic"
        className={Style.BtnToggle}
      >
        <PersonFill className={Style.iconHolder} size={96} />
      </Dropdown.Toggle>
      <Dropdown.Menu className={Style.menuHolder}>
        <Dropdown.Item className={Style.itemHolder} onClick={LogoutHandler}>
          خروج
          <BoxArrowLeft className={Style.exitIcon} />
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DropDownExit;
